import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';
import styled from 'styled-components';

export const SendRequestButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    button {
        width: auto;
        font-size: 18px;
        font-weight: 600;
        padding: 14px;
        text-transform: none;
    }
    @media (max-width: ${BreakPoints.PHONE}) {
        button {
            width: 100%;
        }
    }
`;
